export const defaultTake = 6


// WEBPACK FOOTER //
// ./src/constants/data-query.js